import ExpandableSelector from 'components/UI/V3/ExpandableSelector';
import { ExpandableSelectorItem, ExpandableSelectorList } from 'components/UI/V3/ExpandableSelector/List';
import styles from 'components/UI/V3/Forms/TimeSelector/TimeSelector.module.scss';
import React from 'react';

type TimeOption = {
    id: string;
    label: string;
};

interface TimeSelectorProps {
    label?: string;
    value?: TimeOption;
    options: Array<TimeOption>;
    disabled?: boolean;
    onChange: (id: string) => void;
}

export const TimeSelector: React.FC<TimeSelectorProps> = ({ label, value, options, disabled, onChange }) => {
    const [isExpanded, setIsExpanded] = React.useState(false);

    const expandHandler = React.useCallback(() => {
        setIsExpanded(!isExpanded);
    }, [isExpanded]);

    const selectOptionHandler = React.useCallback(
        (id: string) => {
            onChange(id);
            setIsExpanded(false);
        },
        [onChange]
    );

    return (
        <ExpandableSelector
            title={label}
            label={value?.label}
            id="time-selector"
            expanded={isExpanded}
            onExpand={expandHandler}
            disabled={disabled}
            onClickAway={() => setIsExpanded(false)}
        >
            <ExpandableSelectorList>
                {options.map(({ id, label }) => (
                    <ExpandableSelectorItem
                        key={id}
                        selected={value?.id === id}
                        onClick={() => selectOptionHandler(id)}
                    >
                        {label}
                    </ExpandableSelectorItem>
                ))}
            </ExpandableSelectorList>
        </ExpandableSelector>
    );
};
